export default "__VITE_ASSET__A5ZH7Ya8__"